<template>
  <b-container fluid>
      <iq-card>

          <!-- Title -->
          <template v-slot:headerTitle>
              <h4 class="card-title">
                  {{ $t('grant_budget_management.budget_management') }}
              </h4>
          </template>

          <!-- Body -->
          <template v-slot:body>
            <b-row>
                <b-col xl="12" lg="12" sm="12">
                    <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                        <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" enctype="multipart/form-data">
                            <b-row>
                                <!-- Fiscal Year -->
                                <b-col xl="6" lg="6" sm="12">
                                    <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="fiscal_year_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{ $t('globalTrans.fiscal_year') }} <span class="text-danger">*</span>
                                        </template>
                                        <b-form-select
                                            plain
                                            v-model="search.fiscal_year_id"
                                            :options="fiscalYearList"
                                            id="fiscal_year_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>

                                <!-- Month -->
                                <b-col xl="6" lg="6" sm="12">
                                    <ValidationProvider name="month" vid="month_id" rules="">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="month_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{ $t('production_store.month') }}
                                        </template>
                                        <b-form-select
                                            plain
                                            v-model="search.month_id"
                                            :options="monthList"
                                            id="month_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>

                                 <!-- Service Type -->
                                 <b-col xl="6" lg="6" sm="12">
                                    <ValidationProvider name="Service Type" vid="service_type_id" rules="">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="service_type_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{ $t('grant_budget_management.service_type') }}
                                        </template>
                                        <b-form-select
                                            plain
                                            v-model="search.service_type_id"
                                            :options="serviceTypeList"
                                            id="service_type_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>

                                 <!-- Service -->
                                <b-col xl="6" lg="6" sm="12">
                                    <ValidationProvider name="Service" vid="service_id" rules="">
                                        <b-form-group
                                            class="row"
                                            label-cols-sm="4"
                                            label-for="service_id"
                                            slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                            {{ $t('grant_budget_management.service_name') }}
                                        </template>
                                        <b-form-select
                                            plain
                                            v-model="search.service_id"
                                            :options="serviceList"
                                            id="service_id"
                                            :state="errors[0] ? false : (valid ? true : null)"
                                        >
                                        <template v-slot:first>
                                            <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                        </template>
                                        </b-form-select>
                                        <div class="invalid-feedback">
                                            {{ errors[0] }}
                                        </div>
                                        </b-form-group>
                                    </ValidationProvider>
                                </b-col>
                            </b-row>

                            <!-- Search -->
                            <div class="row">
                                <div class="col text-right">
                                    <b-button type="submit" variant="primary" class="mr-2">{{ $t('globalTrans.search') }}</b-button>
                                </div>
                            </div>
                        </b-form>
                    </ValidationObserver>
                </b-col>
            </b-row>
          </template>
      </iq-card>

      <iq-card>
        <template v-slot:body>
            <b-row>
                <b-col cols="4" class="custom-box-shadow">
                    <div class="bg-primary p-3 rounded mb-3 text-center">
                        <h5 class="text-white d-block">
                            {{ $t('grant_budget_management.prepared_budget')}}
                        </h5>
                        <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
                        <h2 v-else class="text-white">{{ $n(result.amount) }}</h2>
                    </div>
                </b-col>
                <b-col cols="4" class="custom-box-shadow">
                    <div class="bg-primary p-3 rounded mb-3 text-center">
                        <h5 class="text-white d-block">
                            {{ $t('grant_budget_management.approval_budget')}}
                        </h5>
                        <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
                        <h2 v-else class="text-white">{{ $n(result.approve_amount) }}</h2>
                    </div>
                </b-col>
                <b-col cols="4" class="custom-box-shadow">
                    <div class="bg-primary p-3 rounded mb-3 text-center">
                        <h5 class="text-white d-block">
                            {{ $t('grant_budget_management.pending_budget')}}
                        </h5>
                        <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
                        <h2 v-else class="text-white">{{ $n(result.pending_ammount) }}</h2>
                    </div>
                </b-col>
            </b-row>
        </template>
      </iq-card>

  </b-container>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import { dashboardApi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'

export default {
  mixins: [ModalBaseMasterList],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      districtList: [],
      serviceList: [],
      search: {
        fiscal_year_id: 0,
        month_id: 0,
        service_type_id: 0,
        service_id: 0
      },
      result: {
          amount: 0,
          approve_amount: 0,
          pending_ammount: 0
      }
    }
  },
  computed: {
    fiscalYearList: function () {
        return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    monthList: function () {
        return this.$store.state.commonObj.monthList
    },
    serviceTypeList () {
      const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceTypeList
      return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
              return { value: obj.value, text: obj.text_bn }
          } else {
              return { value: obj.value, text: obj.text_en }
          }
      })
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {
    'search.service_type_id': function (newVal, oldVal) {
        this.search.service_id = 0
        this.serviceList = this.getServiceListByType()
    },
    '$i18n.locale': function (newValue) {
        this.serviceList = this.getServiceListByType()
    }
  },
  methods: {
    getServiceListByType () {
        const objectData = this.$store.state.GrantAllowanceService.commonObj.serviceNameList.filter(item => item.service_type_id === this.search.service_type_id && item.has_public_form === 1)
        return objectData.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    async searchData () {
        const params = Object.assign({}, this.search)
        this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })

        RestApi.getData(grantAllowanceServiceBaseUrl, dashboardApi, params).then(response => {
            if (response.success && response.data) {
                this.result.amount = response.data.amount
                this.result.approve_amount = response.data.approve_amount
                this.result.pending_ammount = response.data.pending_ammount
            } else {
                this.$refs.form.setErrors(response.errors)
            }
            this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
        })
    }
  }
}
</script>
